import { useState, useCallback } from "react";
import { apiClient } from "../../../utils/Api";
import { normalizeError } from "../../../utils";

export const usePostAnchantoReserve = () => {
    const [isFetch, setIsFetch] = useState(false);

    const postAnchantoReserve = useCallback((payload) => {
        setIsFetch(true);
        return apiClient()
            .post('/admins/anchanto/reserve', payload)
            .then((res) => res.data)
            .catch((err) => { throw normalizeError(err); })
            .finally(() => setIsFetch(false));
    }, []);

    return { isFetch, postAnchantoReserve };
};
